import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { language } from "app/config";
import ruShared from "shared/i18n/ru";
import enShared from "shared/i18n/en";

const fallbackLng = language ?? ["ru"];

export const resources = {
  ru: { shared: ruShared },
  en: { shared: enShared },
} as const;

const options = {
  // order and from where user language should be detected
  order: ["querystring", "localStorage"],

  // keys or params to lookup language from
  lookupQuerystring: "lng",
  lookupLocalStorage: "language",

  // cache user language on
  caches: ["localStorage"],
  excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)
};

i18n
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng,
    detection: options,
    debug: false,
    ns: ["translation"],
    resources,
  });

export default i18n;
